import {
    FETCH_TOP_STRENGTH_TOP_DEV_START,
    FETCH_TOP_STRENGTH_TOP_DEV_SUCCESS,
    FETCH_TOP_STRENGTH_TOP_DEV_FAIL,

} from "../../../constants";
import {
    FETCH_TOP_STRENGTH_TOP_DEV_URL,
} from "../../../../../config/constants";
import { ApiBase } from "../../../../utils/apiBase";
import { withType } from "../../../../utils/actionOperations";
import { getProjectIdAndOrgId } from '../../../../utils/apiUtils';
import { SETTINGS_PAGE_SECTION } from "../../../../../config/tabConstants";

export const getTopStrengthTopDev = (payload, cb) => {
    const apiBaseInstance = new ApiBase().instance;
    return (dispatch) => {
        dispatch(
            withType(FETCH_TOP_STRENGTH_TOP_DEV_START, { ...payload })
        );
        return apiBaseInstance
            .post(FETCH_TOP_STRENGTH_TOP_DEV_URL, {
                benchmarkFilters: payload, ...getProjectIdAndOrgId(payload),currentTab: SETTINGS_PAGE_SECTION.SETTINGS_SUB_TABS.ADMINISTRATOR
            })
            .then((res) => {
                dispatch(
                    withType(FETCH_TOP_STRENGTH_TOP_DEV_SUCCESS, {
                        data: res.data,
                        payload: payload
                    })
                );
                cb && cb()
            })
            .catch((err) => {
                dispatch(withType(FETCH_TOP_STRENGTH_TOP_DEV_FAIL, { ...err, ...payload }));
                cb && cb()
            });
    };
};

